module.exports = __webpack_public_path__ + "static/media/appratingsandreviewmonitor.e52b082c.png";